/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs'

const $nsid = 'app.bsky.feed.getAuthorFeed'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  actor: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  filter: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'posts_with_replies',
          'posts_no_replies',
          'posts_with_media',
          'posts_and_author_threads',
          'posts_with_video',
        ]
      }>(),
      'posts_with_replies',
    ),
  ),
  includePins: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  feed: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<FeedDefs.FeedViewPost>(
      (() => FeedDefs.feedViewPost) as any,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get a view of an actor's 'author feed' (post and reposts by the author). Does not require auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, [
  'BlockedActor',
  'BlockedByActor',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
